var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageDecorTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 900,
  height: 900,
  fill: "none",
  viewBox: "0 0 575 575"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#FAE632",
  strokeMiterlimit: 10,
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M287.499 326.217c21.383 0 38.717-17.334 38.717-38.717s-17.334-38.716-38.717-38.716-38.716 17.334-38.716 38.716 17.334 38.717 38.716 38.717Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.499 385.065c53.884 0 97.565-43.681 97.565-97.565s-43.681-97.565-97.565-97.565-97.564 43.681-97.564 97.565 43.681 97.565 97.564 97.565Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.501 450.108c89.806 0 162.608-72.802 162.608-162.608s-72.802-162.608-162.608-162.608S124.893 197.694 124.893 287.5s72.802 162.608 162.608 162.608Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.499 512.054c124.018 0 224.554-100.536 224.554-224.554 0-124.017-100.536-224.554-224.554-224.554-124.017 0-224.554 100.537-224.554 224.554 0 124.018 100.537 224.554 224.554 224.554Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.5 574C445.73 574 574 445.73 574 287.5S445.73 1 287.5 1 1 129.27 1 287.5 129.27 574 287.5 574Z"
}))));
export default SvgHomepageDecorTop;